import Vector from "victor";

export interface Library {
  name: string;
  images: { url: string; size: Vector }[];
}

const MUSIC_SIZE = new Vector(1253, 2293).divideScalar(50);

export const LIBRARIES: [Library] = [
  {
    name: "Music",
    images: [
      { url: `/static/library/music/metNoteWhole.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNoteHalfUp.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNoteHalfDown.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNoteQuarterUp.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNoteQuarterDown.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNote8thUp.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNote8thDown.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNote16thUp.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNote16thDown.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/metNote32ndUp.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/restWhole.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/restQuarter.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/rest16th.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/rest32nd.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/repeatLeft.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/repeatRight.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/accidentalFlat.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/accidentalSharp.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/accidentalNatural.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/ornamentShortTrill.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/dynamicPiano.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/dynamicForte.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/fermataAbove.svg`, size: MUSIC_SIZE },
      {
        url: `/static/library/music/dynamicCrescendoHairpin.svg`,
        size: MUSIC_SIZE,
      },
      {
        url: `/static/library/music/dynamicDiminuendoHairpin.svg`,
        size: MUSIC_SIZE,
      },
      { url: `/static/library/music/fClef.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/gClef.svg`, size: MUSIC_SIZE },
      { url: `/static/library/music/cClef.svg`, size: MUSIC_SIZE },
    ],
  },
];

export function replaceLibraries(newLibraries: [Library]) {
  while (LIBRARIES.length) {
    LIBRARIES.pop();
  }
  for (const l of newLibraries) {
    LIBRARIES.push(l);
  }
}
